export const testimonials = [
  {
    id: "t1",
    name: "投稿人・小周",
    role: "自媒体从业者",
    avatar: "ri-user-3-line",
    content:
      "我投过三条线索，其中一条进入了发酵。后台没有问我姓名，只在需要补充材料时用编号回复，这点让我很放心。",
  },
  {
    id: "t2",
    name: "匿名・片场场务",
    role: "多次投稿用户",
    avatar: "ri-user-star-line",
    content:
      "写爆料最怕被对号入座。511爆料的审核会先帮我把可能暴露身份的细节去掉，再决定是否展示，专业度比我预想的高。",
  },
  {
    id: "t3",
    name: "读者・阿凯",
    role: "广场常驻读者",
    avatar: "ri-user-smile-line",
    content:
      "我喜欢这里的状态标签，发酵中、待补充、已核实写得很清楚，不会把猜测当成结论，读起来不累。",
  },
  {
    id: "t4",
    name: "投稿人・L 同学",
    role: "校园线索投喂",
    avatar: "ri-user-4-line",
    content:
      "本来只是抱着试试的心态投喂了一条校园线索，没想到第二天就收到审核回复，还给了补充建议，被认真对待的感觉挺好。",
  },
];

export const processSteps = [
  {
    step: "01",
    title: "提交线索",
    desc: "私信投稿、投稿表单或一键爆料，任选一种方式，无需注册即可提交。",
  },
  {
    step: "02",
    title: "脱敏与审核",
    desc: "后台在三十八分钟左右完成初审，先做身份脱敏，再判断信息是否可核对。",
  },
  {
    step: "03",
    title: "交叉核实",
    desc: "把时间线拆成独立信息点，分别向不同信源求证，避免单一来源下结论。",
  },
  {
    step: "04",
    title: "进入发酵",
    desc: "被采纳的瓜料进入热门发酵环节，持续更新状态标签，并保持对投稿人的回应。",
  },
];